import { logRoutes } from './logs';

export const accessRoutes = [
  {
    path: 'access',
    children: [...logRoutes],
  },
];
